module.exports = __webpack_public_path__ + "static/media/something-went-wrong.951a1593.svg";